export default "__VITE_ASSET__CmvHEKnF__"